import script from "./FinishedGameTable.vue?vue&type=script&setup=true&lang=js"
export * from "./FinishedGameTable.vue?vue&type=script&setup=true&lang=js"

import "./FinishedGameTable.vue?vue&type=style&index=0&id=62891681&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62891681"]])

export default __exports__